import { KitsById } from "../modules/kits";

export const KitsByIdPage = () => {
  return <KitsById />;
};
